export default (theme) => ({
    root: {
        boxSizing: 'border-box',
        borderRadius: 6,
        boxShadow: '0 1px 6px 0 rgba(32, 33, 36, 0.38)',
        overflow: 'hidden',
    },
    header: {
        width: '100%',
        height: 40,
        boxSizing: 'border-box',
        padding: '0 16px 0 16px',
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    body: {
        width: '100%',
        maxHeight: 360,
        boxSizing: 'border-box',
        padding: 16,
        overflow: 'auto',
        ...theme.utils.scrollbar,
    },
    actions: {},
    action: {
        width: 14,
        height: 14,
        cursor: 'pointer',
        '& svg': {
            width: 14,
            height: 14,
            '& path': {
                fill: theme.colors.actionMinor[500],
            },
            '&:hover': {
                '& path': {
                    fill: theme.colors.actionMinor[600],
                },
            },
        },
    },
});
